import React from 'react';
import { Spin } from 'antd';
import './index.less';
import ABSIcon from '../ABSIcon';

export interface IABSLoadingProps {
    size?: 'small' | 'default' | 'large';
    color?: 'blue' | 'white';
    className?: string;
}

class ABSLoading extends React.Component<IABSLoadingProps> {
  public static defaultProps = {
    size: 'default',
    color: 'blue',
  };

  render() {
    const { size, color, className } = this.props;
    const iconClass = `abs-loading-${size} abs-loading-${color} ${className}`;
    let iconSize = 24;
    if (size === 'small') {
      iconSize = 14;
    } else if (size === 'large') {
      iconSize = 32;
    }
    const icon = <ABSIcon size={iconSize} isAnt={true} type="loading" className={iconClass} />;
    return(
      <div className="abs-loading">
        <Spin indicator={icon} className={`abs-loading-${size}`} />
      </div>
    );
  }
}

export default ABSLoading;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSLoading/index.tsx